import { createContext } from 'react';

// Shared Doc Assistant capture state, provided by SaveToContainer so the poll loop persists across the
// search <-> selected-record navigation a match triggers. Consumers: the Assign with ACE button and the
// search view's "Searching matters with ACE" skeleton.
export const DocAssistantCaptureContext = createContext({
  status: 'idle',
  banner: null,
  startCapture: () => {},
  dismissBanner: () => {},
});
